import React, { useMemo, useState } from "react";
import { HiOutlineMail, HiCheckCircle } from "react-icons/hi";
import { AiOutlineLoading } from "react-icons/ai";
import { GoAlertFill } from "react-icons/go";
import axiosInstance from "../config/axiosInstance";
import { PASSWORD_RECOVERY } from "../config/apiConfig";
import "./forgot-password.css";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const canSubmit = useMemo(
    () => email.trim().length > 5 && !loading,
    [email, loading]
  );

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!canSubmit) return;

    setLoading(true);
    setError(null);
    setMessage(null);

    try {
      const { data } = await axiosInstance.post(PASSWORD_RECOVERY.FORGOT, {
        email: email.trim(),
      });

      setMessage(
        data?.message ||
          `Enviamos um link para ${email.trim()}, confira sua caixa de entrada.`
      );
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          "Não foi possível enviar o link. Tente novamente em instantes."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-poster">
      <header className="forgot-header">
        <div className="forgot-brand">
          <div className="forgot-brand__logo">
            {" "}
            <img
              src="/assets/logo_mobile.png"
              className="login-mobile-logo"
              alt="Relinq Sales"
            />
          </div>
          <div className="forgot-brand__text">
            <span>
              Relinq<span>Sales</span>
            </span>
            <div className="forgot-brand__subtitle">
              CRM focado em conversão
            </div>
          </div>
        </div>
        <a className="link" href="/login">
          Voltar ao login
        </a>
      </header>

      <main className="forgot-main">
        <section className="forgot-hero">
          <p className="badge">Esqueceu a senha</p>
          <h1>
            Recuperar acesso
            <br />
            com segurança e rapidez
          </h1>
          <p>
            Chegaremos ao seu e-mail com o link seguro. Ele permite criar uma
            nova senha e voltar para sua rotina de vendas em poucos minutos.
          </p>
        </section>

        <section className="forgot-card">
          <div className="forgot-card__header">
            <span className="muted">Segurança</span>
            <span className="muted">Confidencialidade garantida</span>
          </div>

          <h2>Recupere sua senha</h2>
          <p className="muted">
            Informe o e-mail que você usa no Relinq Sales, iremos enviar um link
            seguro para redefinir sua senha.
          </p>

          <form className="forgot-form" onSubmit={handleSubmit} noValidate>
            <label className="input-label" htmlFor="forgot-email">
              E-mail cadastrado
            </label>
            <div className="input-wrap">
              <HiOutlineMail className="input-icon" />
              <input
                id="forgot-email"
                type="email"
                placeholder="nome@empresa.com"
                autoComplete="username"
                value={email}
                onChange={(ev) => setEmail(ev.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className={`btn btn--primary ${
                !canSubmit ? "btn--disabled" : ""
              }`}
              disabled={!canSubmit}
            >
              {loading ? <AiOutlineLoading className="spin" /> : "Enviar link"}
            </button>

            {message && <div className="alert alert--success">{message}</div>}
            {error && (
              <div className="alert alert--error">
                <GoAlertFill /> {error}
              </div>
            )}
          </form>
        </section>
      </main>

      <footer className="forgot-footer">
        © {new Date().getFullYear()} Relinq Sales. Todos os direitos reservados.
      </footer>

      <div className="bg-radial-1" />
      <div className="bg-radial-2" />
      <div className="bg-grid" aria-hidden />
      <div className="bg-vignette" />
    </div>
  );
}
